















import { Component, Prop, Provide, Vue } from 'vue-property-decorator';
import SingleAvatar from '@/components/SingleAvatar.vue';
import { allCharactersArray } from '@/custom-properties';

@Component({
    components: { SingleAvatar }
})
export default class All extends Vue {
    characters: any = allCharactersArray;

    size = 'default';

    @Prop({
        type: String,
        default: 'abstract-avatars'
    })
    setName!: string;

    created() {
        const params = new URLSearchParams(window.location.search);
        if (params.has('size')) {
            this.size = params.get('size') as string;
        }
    }
}
